export function validarCep(cep) {
  return cep.replace('-', '').match(/^[0-9]{8}$/);
}
